import axios from "../axios";
import { Cookies } from "react-cookie";
const endPoint = `/crm/lead/`;

const cookie = new Cookies();

export const getAllLeads = async (page, search, searchBy) => {
  const token = cookie.get("crm");
  const res = await axios.get(
    `${endPoint}all?page=${page}&search=${search}&searchBy=${searchBy}`,
    {
      headers: { Authorization: token },
    },
  );
  return res;
};

export const getAllCompaniesLeads = async (page, search, searchBy) => {
  const token = cookie.get("crm");
  const res = await axios.get(
    `${endPoint}all_companies_leads?page=${page}&search=${search}&searchBy=${searchBy}`,
    {
      headers: { Authorization: token },
    },
  );
  return res;
};

export const getUsersLeads = async (page, search, searchBy) => {
  const token = cookie.get("crm");
  const res = await axios.get(
    `${endPoint}all_users_leads?page=${page}&search=${search}&searchBy=${searchBy}`,
    {
      headers: { Authorization: token },
    },
  );
  return res;
};

export const createBulk = async ({ data }) => {
  const token = cookie.get("crm");
  const formData = new FormData();
  formData.append("data", JSON.stringify(data));
  const res = await axios.post(`${endPoint}createbulk`, formData, {
    headers: { Authorization: token },
  });
  return res;
};

export const assign = async ({ leads, broker, brokername }) => {
  const token = cookie.get("crm");
  const res = await axios.post(
    `${endPoint}assign`,
    { leads, broker, brokername },
    { headers: { Authorization: token } },
  );
  return res;
};
export const selfAssign = async ({ leads }) => {
  const token = cookie.get("crm");
  const res = await axios.post(
    `${endPoint}selfassign`,
    { leads },
    { headers: { Authorization: token } },
  );
  return res;
};

export const addActionForLead = async ({ id, action, actionTime, comment }) => {
  const token = cookie.get("crm");
  const res = await axios.put(
    `${endPoint}add_action_for_lead?id=${id}`,
    { action, actionTime, comment },
    { headers: { Authorization: token } },
  );
  return res;
};

export const updateLead = async ({ id, body }) => {
  const token = cookie.get("crm");
  const res = await axios.put(`${endPoint}update?id=${id}`, body, {
    headers: { Authorization: token },
  });
  return res;
};

export const getallwithaction = async () => {
  const token = cookie.get("crm");
  const res = await axios.get(`${endPoint}action`, {
    headers: { Authorization: token },
  });
  return res;
};

export const getfiles = async () => {
  const token = cookie.get("crm");
  const res = await axios.get(`${endPoint}files`, {
    headers: { Authorization: token },
  });
  return res;
};
export const createSingleLead = async (data) => {
  console.log(data);
  const token = cookie.get("crm");
  const res = await axios.post(`${endPoint}create`, data, {
    headers: { Authorization: token },
  });
  return res;
};

export const getLeadsByType = async (
  page,
  description,
  type,
  search,
  searchBy,
  assign,
  isMe,
) => {
  const token = cookie.get("crm");
  const res = await axios.get(
    `${endPoint}all_leads_by_type?page=${page}&description=${description}&type=${type}&search=${search}&searchBy=${searchBy}&assign=${assign}&isMe=${isMe}`,
    {
      headers: { Authorization: token },
    },
  );
  return res;
};

export const assiciatedCreation = async () => {
  const token = cookie.get("crm");
  const res = await axios.get(`${endPoint}associatedcreation`, {
    headers: { Authorization: token },
  });
  return res;
};
export const marketing = async () => {
  const token = cookie.get("crm");
  const res = await axios.get(`${endPoint}marketing`, {
    headers: { Authorization: token },
  });
  return res;
};

export const assignMass = async ({ leads, brokers }) => {
  const token = cookie.get("crm");
  const res = await axios.post(
    `${endPoint}assign/v2`,
    { leads, brokers },
    { headers: { Authorization: token } },
  );
  return res;
};

export const deleteLeads = async ({ leads }) => {
  const token = cookie.get("crm");
  const res = await axios.delete(`${endPoint}/bulk_delete`, {
    data: { leads },
    headers: { Authorization: token },
  });
  return res;
};

export const getChannelsAndProjects = async () => {
  const token = cookie.get("crm");
  const res = await axios.get(`${endPoint}/channels_and_projects`, {
    headers: { Authorization: token },
  });
  return res;
};
